module.exports = __webpack_public_path__ + "img/desktop-register.8a71e98b.svg";